var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe03Duotone = function SvgGlobe03Duotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M16 2.667c4 2.666 5.23 8.389 5.333 13.333C21.23 20.944 20 26.667 16 29.333m0-26.666C12 5.333 10.77 11.056 10.667 16 10.77 20.944 12 26.667 16 29.333m0-26.666C8.636 2.667 2.667 8.637 2.667 16M16 2.667c7.364 0 13.333 5.97 13.333 13.333M16 29.333c7.364 0 13.333-5.97 13.333-13.333M16 29.333c-7.364 0-13.333-5.97-13.333-13.333m26.666 0c-2.666 4-8.389 5.23-13.333 5.333C11.056 21.23 5.333 20 2.667 16m26.666 0c-2.666-4-8.389-5.23-13.333-5.333C11.056 10.77 5.333 12 2.667 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FF",
    stroke: "#516B89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M16 10.667c-1.575.033-3.23.18-4.838.495-.315 1.609-.463 3.263-.495 4.838.033 1.575.18 3.23.495 4.839 1.609.314 3.263.462 4.838.494 1.575-.032 3.23-.18 4.839-.494.314-1.61.462-3.264.494-4.839-.032-1.575-.18-3.23-.494-4.838-1.61-.315-3.264-.463-4.839-.495"
  })));
};
export default SvgGlobe03Duotone;